export enum Widgets {
  PlayerOfTheDay = 'playerOfTheDay',
  LuckOfTheDay = 'luckOfTheDay',
  CasesMotivator = 'casesMotivator',
  Portal = 'portal',
  Event = 'event',
  ThirdPartyBlock = 'thirdPartyBlock',
}
